import { useAppSelector } from "../store/index.ts";
import { ENUM_ACCOUNT_REGISTER } from "../store/enums";

export default function useRequireVerify() {
  const emailVerifyRequire = useAppSelector((state) => state.common.emailVerifyRequire);
  const regType = useAppSelector((state) => state.user.info.regType);
  const confirmEmail = useAppSelector((state) => state.user.info?.emailConfirmed);

  const isRegisterEmail = regType === ENUM_ACCOUNT_REGISTER.email;
  const { deposit, payout, promocode } = emailVerifyRequire;

  const isNeedVerify = !confirmEmail && isRegisterEmail;

  const lockDep = isNeedVerify && deposit;
  const lockPayout = isNeedVerify && payout;
  const lockPromocode = isNeedVerify && promocode;

  return { lockDep, lockPayout, lockPromocode };
}
